import { ROUTES } from 'shared/config/routes'

const DAY_MS = 24 * 60 * 60 * 1000

/** Location state so Student Profile back returns to Dashboard priority tab + scroll. */
export const dashboardPriorityBackState = (priorityTab = null) => ({
	backTo: { type: 'dashboard', priorityTab: priorityTab || null },
})

export const navigateToStudentProfile = (navigate, studentId, navOptions) => {
	const id = String(studentId || '').trim()
	if (!id) return
	navigate(
		`${ROUTES.STUDENT_PROFILE}/${encodeURIComponent(id)}`,
		navOptions,
	)
}

export const navigateToStudentProfileFromPriority = (
	navigate,
	studentId,
	priorityTab = null,
) => {
	navigateToStudentProfile(navigate, studentId, {
		state: dashboardPriorityBackState(priorityTab),
	})
}

const toStartOfDay = value => {
	const date = new Date(value)
	if (Number.isNaN(date.getTime())) return null
	return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

export const getEssayTypeLabel = scope => {
	const normalized = String(scope || '').toLowerCase()
	if (normalized === 'common_app') return 'Common App Essay'
	if (normalized === 'individual' || normalized === 'supplemental')
		return 'Supplemental Essay'
	return 'Essay'
}

export const getUrgencyMeta = item => {
	const rawDate =
		item?.applicationDeadline || item?.deadline || item?.dueDate || item?.due || null
	if (!rawDate) return null
	const target = toStartOfDay(rawDate)
	const today = toStartOfDay(new Date())
	if (!target || !today) return null
	const daysLeft = Math.ceil((target.getTime() - today.getTime()) / DAY_MS)
	if (daysLeft < 0 || daysLeft >= 20) return null
	return {
		label: 'Urgent',
		daysLeft,
	}
}

export const getDeadlineTone = item => {
	const rawDate =
		item?.applicationDeadline || item?.deadline || item?.dueDate || item?.due || null
	if (!rawDate) return 'purple'
	const target = toStartOfDay(rawDate)
	const today = toStartOfDay(new Date())
	if (!target || !today) return 'purple'
	const daysLeft = Math.ceil((target.getTime() - today.getTime()) / DAY_MS)
	if (daysLeft < 20) return 'urgent'
	if (daysLeft < 45) return 'purple'
	return 'success'
}

export const getCollectionDeadlineTone = items => {
	const list = Array.isArray(items) ? items : []
	if (!list.length) return 'purple'
	if (list.some(item => getDeadlineTone(item) === 'urgent')) return 'urgent'
	if (list.some(item => getDeadlineTone(item) === 'purple')) return 'purple'
	return 'success'
}
